import { render, staticRenderFns } from "./PopupPreview.vue?vue&type=template&id=2f945da2&scoped=true"
import script from "./PopupPreview.vue?vue&type=script&lang=js"
export * from "./PopupPreview.vue?vue&type=script&lang=js"
import style0 from "./PopupPreview.vue?vue&type=style&index=0&id=2f945da2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f945da2",
  null
  
)

export default component.exports